// @flow
import React from "react";
import { connect } from "react-redux";
import type { ReduxState } from "../reducers/reducers.tsx";
import "./BadgeNumberAlerts.scss";

export const DARK_RED = "#bb1e1d";

type Props = {
    num_unread_alerts: number,
};
type State = {};

class BadgeNumberAlerts extends React.Component<Props, State> {
    render() {
        if (this.props.num_unread_alerts <= 0) {
            return null;
        }

        const style = {
            color: "white",
            backgroundColor: DARK_RED,
            marginLeft: "6px",
        };

        return (
            <span className="badge-number-alerts" style={style}>
                {this.props.num_unread_alerts}
            </span>
        );
    }
}

export default connect((state: ReduxState) => {
    return {
        num_unread_alerts: state.alerts.num_unread_alerts,
    };
}, null)(BadgeNumberAlerts);
